import { render } from "./onboarding-email.vue?vue&type=template&id=ce6f11a2"
import script from "./onboarding-email.vue?vue&type=script&lang=js"
export * from "./onboarding-email.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__